import { Link } from 'react-router-dom';
import { getHotVideos } from '@/mocks/videos';
import VideoCard from '@/components/base/VideoCard';

export default function HotVideos() {
  const hotVideos = getHotVideos(6);

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              热门视频
            </h2>
            <p className="text-sm text-foreground-500 mt-2">全网最火的原创视频，大家都在看</p>
          </div>
          <Link
            to="/category/gaoxiao"
            className="hidden sm:flex items-center gap-1 text-sm text-[oklch(var(--primary-500))] font-medium hover:underline whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {hotVideos.map((video) => (
            <VideoCard
              key={video.id}
              id={video.id}
              title={video.title}
              thumbnail={video.thumbnail}
              authorName={video.authorName}
              authorAvatar={video.authorAvatar}
              views={video.views}
              likes={video.likes}
              duration={video.duration}
              categoryName={video.categoryName}
              categorySlug={video.categorySlug}
            />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/gaoxiao"
            className="inline-flex items-center gap-1 text-sm text-[oklch(var(--primary-500))] font-medium hover:underline whitespace-nowrap"
          >
            查看更多热门视频 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}